import { Grid, TextField, Typography } from "@material-ui/core";
import datetimeHelper from "helper/datetime-helper";

const TicketHistoryDetail = ({ ticketData }) => {
  const isTicketType = (ticketTypeName) => {
    return ticketData?.ticketType?.name?.toLowerCase().includes(ticketTypeName);
  };

  return (
    <div style={{ marginTop: 12, marginBottom: 12 }}>
      {/* Thông tin khách hàng */}
      {/* <Grid container style={{ marginTop: "12px " }} spacing={24}>
        <Grid item xs={12}>
          <Typography
            style={{
              backgroundColor: "#d3d4d9",
              padding: "5px 15px",
              fontSize: 18,
            }}>
            Thông tin khách hàng
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Số điện thoại liên hệ"
            variant="outlined"
            name="customerPhone"
            value={ticketData?.phone || ""}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Tên khách hàng"
            variant="outlined"
            name="customerName"
            value={
              (ticketData?.contact?.firstName || "") +
              (ticketData?.contact?.lastName || "")
            }
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Email"
            variant="outlined"
            name="customerEmail"
            value={ticketData?.contact?.email || ""}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Địa chỉ khách hàng"
            variant="outlined"
            name="OwnerId"
            value={ticketData?.customFields?.Address}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
      </Grid> */}

      {/* Thông tin ticket */}
      <Grid container spacing={24}>
        <Grid item xs={12}>
          <Typography
            style={{
              backgroundColor: "#d3d4d9",
              padding: "5px 15px",
              fontSize: 18,
            }}>
            Thông tin ticket
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Tiêu đề"
            variant="outlined"
            value={ticketData?.attributes?.ticketDetail || ""}
            multiline
            rows={2}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Mô tả"
            variant="outlined"
            value={ticketData?.attributes?.description || ""}
            multiline
            rows={2}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Ngày tạo"
            variant="outlined"
            value={
              datetimeHelper.toFormat(
                ticketData?.createdAt,
                "YYYY-MM-DD HH:mm:ss"
              ) || ""
            }
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Tên khách hàng"
            variant="outlined"
            value={ticketData?.attributes?.customerName || ""}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Số điện thoại"
            variant="outlined"
            value={ticketData?.attributes?.customerPhone || ""}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Email"
            variant="outlined"
            value={ticketData?.attributes?.customerEmail || ""}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Địa chỉ"
            variant="outlined"
            value={ticketData?.attributes?.customerAddress || ""}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
        {/* <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Chi tiết yêu cầu"
            variant="outlined"
            name="Description"
            value={ticketData?.description.replace(/<br>/g, "\n") || ""}
            multiline
            rows={6}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid> */}
        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            label="Trạng thái"
            id="outlined-full-width"
            variant="outlined"
            name="status"
            value={ticketData?.statusText || ""}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
        {/* <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Mã tin thu gom/Mã vận đơn"
            variant="outlined"
            value={ticketData?.attributes?.packageCode || ""}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid> */}

        {/* <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Dịch vụ"
            variant="outlined"
            value={
              SERVICES_OPTIONS.find(
                (item) => item.key === ticketData?.attributes?.service
              )?.name || ""
            }
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Sản phẩm"
            variant="outlined"
            value={ticketData?.attributes?.product || ""}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Loại yêu cầu"
            variant="outlined"
            name="type"
            value={ticketData?.ticketType?.name || ""}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Nội dung yêu cầu"
            variant="outlined"
            name="type"
            value={ticketData?.attributes?.ticketDetail || ""}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
          <TextField
            id="outlined-full-width"
            label="Chi tiết yêu cầu"
            variant="outlined"
            name="Description"
            value={ticketData?.description.replace(/<br>/g, "\n") || ""}
            multiline
            rows={5}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid> */}

        {/* {isTicketType("tư vấn dịch vụ") && (
          <>
            <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
              <TextField
                id="outlined-full-width"
                label="Đơn vị xử lý"
                variant="outlined"
                name="createdAt"
                value={
                  ticketData?.attributes?.transferUnit
                    ? `${ticketData?.attributes?.transferUnit?.code} - ${ticketData?.attributes?.transferUnit?.name}` ||
                      ""
                    : null
                }
                InputProps={{
                  readOnly: true,
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
              <TextField
                id="outlined-full-width"
                label="Mặt hàng kinh doanh"
                variant="outlined"
                name="createdAt"
                value={ticketData?.attributes?.businessProduct || ""}
                InputProps={{
                  readOnly: true,
                }}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
              <TextField
                id="outlined-full-width"
                label="Sản lượng/tháng"
                variant="outlined"
                name="status"
                value={ticketData?.attributes?.outputPerMonth || ""}
                InputProps={{
                  readOnly: true,
                }}
                fullWidth
              />
            </Grid>
          </>
        )}

        {isTicketType("khiếu nại") && (
          <>
            <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
              <TextField
                id="outlined-full-width"
                label="Đơn vị chủ trì"
                variant="outlined"
                name="createdAt"
                value={
                  ticketData?.attributes?.hostUnit
                    ? `${ticketData?.attributes?.hostUnit?.name}` || ""
                    : null
                }
                InputProps={{
                  readOnly: true,
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
              <TextField
                id="outlined-full-width"
                label="Đơn vị liên quan"
                variant="outlined"
                name="createdAt"
                value={
                  ticketData?.attributes?.relatedUnit
                    ? `${ticketData?.attributes?.relatedUnit?.name}` || ""
                    : null
                }
                InputProps={{
                  readOnly: true,
                }}
                fullWidth
              />
            </Grid>
          </>
        )} */}
      </Grid>

      {/* {ticketData?.tasks?.length > 0 && (
        <Grid container style={{ marginTop: "12px " }} spacing={24}>
          <Grid item xs={12}>
            <Typography
              style={{
                backgroundColor: "#d3d4d9",
                padding: "5px 15px",
                fontSize: 18,
              }}>
              Thông tin nhiệm vụ
            </Typography>
          </Grid>

          {(ticketData?.tasks || []).map((item) => (
            <>
              <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                <TextField
                  id="outlined-full-width"
                  label="Loại nhiệm vụ"
                  variant="outlined"
                  value={item?.type || ""}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                <TextField
                  id="outlined-full-width"
                  label="Thời gian thực hiện"
                  variant="outlined"
                  value={moment(item?.actionDate || "").format("DD-MM-YYYY")}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                <TextField
                  id="outlined-full-width"
                  label="Chi tiết nhiệm vụ"
                  variant="outlined"
                  value={item?.description || ""}
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </Grid>
            </>
          ))}
        </Grid>
      )}

      {ticketData.source === "ott" && (
        <Grid container style={{ marginTop: "12px " }} spacing={24}>
          <Grid item xs={12}>
            <Typography
              style={{
                backgroundColor: "#d3d4d9",
                padding: "5px 15px",
                fontSize: 18,
              }}>
              Tên cuộc chat
            </Typography>
          </Grid>

          <Grid item xs={12} style={{ paddingTop: 0 }}>
            <TextField
              id="outlined-full-width"
              variant="outlined"
              name="status"
              value={ticketData?.customFields?.conversationName || ""}
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      )}

      <Grid container style={{ marginTop: "12px " }} spacing={24}>
        <Grid item xs={12}>
          <Typography
            style={{
              backgroundColor: "#d3d4d9",
              padding: "5px 15px",
              fontSize: 18,
            }}>
            Thông tin xử lý
          </Typography>
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <TextField
            id="outlined-full-width"
            variant="outlined"
            multiline
            rows={5}
            value={ticketData?.result || ""}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
      </Grid>

      <Grid container style={{ marginTop: "12px " }} spacing={24}>
        <Grid item xs={12}>
          <Typography
            style={{
              backgroundColor: "#d3d4d9",
              padding: "5px 15px",
              fontSize: 18,
            }}>
            Trạng thái
          </Typography>
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <TextField
            id="outlined-full-width"
            variant="outlined"
            name="status"
            value={ticketData?.status || ""}
            InputProps={{
              readOnly: true,
            }}
            fullWidth
          />
        </Grid>
      </Grid> */}

      {/* {ticketData.source !== "ott" && (
        <Grid container style={{ marginTop: "12px " }} spacing={24}>
          <Grid item xs={12}>
            <Typography
              style={{
                backgroundColor: "#d3d4d9",
                padding: "5px 15px",
                fontSize: 18,
              }}>
              File ghi âm cuộc gọi
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ paddingTop: 0 }}>
            {ticketData?.recordUrl ? (
              <audio
                src={ticketData?.recordUrl || ""}
                controls
                autoPlay={false}
              />
            ) : (
              <p style={{ paddingLeft: 15 }}>Không có file ghi âm!</p>
            )}
          </Grid>
        </Grid>
      )} */}
    </div>
  );
};

export default TicketHistoryDetail;
